import React from 'react';
import { Box } from '@wix/design-system';
import classNames from 'classnames';
import s from './MobileProductCard.scss';
import { MobileProductCardTitle } from './MobileProductCardTitle';
import { MobileProductCardFeatureList } from './MobileProductCardFeatureList';
export const MobileProductCard = ({ className, dataHook, children, ...props }) => {
    return (React.createElement(Box, { direction: "vertical", dataHook: dataHook, borderRadius: props.borderRadius ?? '0.25em', className: classNames(s.productCard, className), ...props }, children));
};
MobileProductCard.Title = MobileProductCardTitle;
MobileProductCard.FeatureList = MobileProductCardFeatureList;
//# sourceMappingURL=MobileProductCard.js.map